import React, { useState } from "react";
import { LuClipboardCheck } from "react-icons/lu";
import { IoIosArrowDown } from "react-icons/io";
import { Form } from "react-bootstrap";
import "../App.css";

function ScoreRubric({ onScoreRubricDataChange }) {
  const [showForm, setShowForm] = useState(false);
  const [radioValue, setRadioValue] = useState("A");
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);

  const buttonStyle = {
    width: "100%",
    backgroundColor: "white",
    color: "#A63D00",
    borderColor: "#A63D00",
    fontFamily: "Manrope-Regular",
  };

  const handleToggleForm = () => {
    setShowForm(!showForm);
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    setRadioValue(value);
    updateScoreRubricData({ radioValue: value });
  };

  const handleCheckbox1 = () => {
    const updatedValue = !checkbox1;
    setCheckbox1(updatedValue);
    updateScoreRubricData({ checkbox1: updatedValue });
  };

  const handleCheckbox2 = () => {
    const updatedValue = !checkbox2;
    setCheckbox2(updatedValue);
    updateScoreRubricData({ checkbox2: updatedValue });
  };

  const updateScoreRubricData = (data) => {
    onScoreRubricDataChange((prevData) => ({ ...prevData, ...data }));
  };

  return (
    <div className="mb-2">
      <button
        className="btn btn-outline-primary d-flex align-items-center justify-content-between mt-2"
        style={buttonStyle}
        onClick={handleToggleForm}
      >
        <LuClipboardCheck size={30} />
        <span>Score & Rubric</span>
        <IoIosArrowDown />
      </button>

      {showForm && (
        <div className="mt-2" style={{ fontFamily: "Manrope-Regular" }}>
          <form className="text-start p-4 border rounded">
            <div className="row mb-3">
              <div className="col">
                <Form.Check
                  type="radio"
                  label="Summative"
                  name="modeOptions"
                  value="A"
                  checked={radioValue === "A"}
                  onChange={handleRadioChange}
                  className="mb-2"
                />
              </div>
              <div className="col">
                <Form.Check
                  type="radio"
                  label="Formative"
                  name="modeOptions"
                  value="B"
                  checked={radioValue === "B"}
                  onChange={handleRadioChange}
                  className="mb-2"
                />
              </div>
            </div>
            <Form.Check
              type="checkbox"
              label="Enable grading"
              checked={checkbox1}
              onChange={handleCheckbox1}
              className="mb-2"
            />

            <Form.Check
              type="checkbox"
              label="Enable Certificate"
              checked={checkbox2}
              onChange={handleCheckbox2}
              className="mb-2"
            />
          </form>
        </div>
      )}
    </div>
  );
}

export default ScoreRubric;
